import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api/erp`,
  headers: { 'Content-Type': 'application/json' }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('erp_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
// - /auth/login, /auth/select-company → giriş hatası, logout
// - /auth/refresh-token, /auth/me → token geçersiz, logout
// - diğer endpointler → sadece hata fırlat, logout etme (geçici ağ sorunu olabilir)
let _logoutPending = false;

// /login'e YALNIZ oturum gerektiren alanlarda yönlendirilir. Girişsiz
// bağlantılar (/rapor, /puantaj, /personel-formu, /portal) da AuthProvider
// içinde çalışıyor; tarayıcıda süresi dolmuş bir ERP oturumu varsa açılıştaki
// /auth/me 401 alıyor ve taşeron/sorumlu formu açılmadan giriş ekranına
// atılıyordu (2026-09-29). Girişsiz sayfaların listesi yerine TERSİNE
// bakılıyor: yeni bir girişsiz sayfa eklenince burayı güncellemek gerekmesin.
const OTURUM_ALANI = ['/erp', '/select-company', '/force-change-password'];
const oturumAlanindaMi = () => {
  const yol = window.location.pathname;
  return OTURUM_ALANI.some((p) => yol === p || yol.startsWith(`${p}/`));
};

const doLogout = () => {
  // Bayat oturum her durumda temizlenir; yönlendirme yalnız oturum alanında.
  localStorage.removeItem('erp_token');
  localStorage.removeItem('erp_company');
  localStorage.removeItem('erp_user');
  localStorage.removeItem('erp_role');
  localStorage.removeItem('erp_permissions');
  if (_logoutPending || !oturumAlanindaMi()) return;
  _logoutPending = true;
  window.location.href = '/login';
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isSessionEndpoint =
        url.includes('/auth/login') ||
        url.includes('/auth/select-company') ||
        url.includes('/auth/refresh-token') ||
        url.includes('/auth/me');
      if (isSessionEndpoint) {
        doLogout();
      }
      // Diğer 401'lerde (veri API'leri) sadece hata fırlat
    }
    return Promise.reject(error);
  }
);

export default api;
